module.exports = __webpack_public_path__ + "static/models/arch_start_lighting.41f422d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/models/track/models/arch_start_lighting.json
// module id = 536
// module chunks = 1